import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import allAPI from "../../api/api";

const initialState = {};

export const getSubCategories = createAsyncThunk(
  "subCategoriesData",
  async (payload) => {
    try {
      const response = await allAPI.subCategories.getSubCategories(payload);
      console.log("✌️response --->", response);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);
export const updateSubCategoryType = createAsyncThunk(
  "updateSubCategoryType",
  async (payload) => {
    try {
      const response =
        await allAPI.subCategories.updateSubCategoryType(payload);
      console.log("✌️response --->", response);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);
export const deleteSubCatergoryMapping = createAsyncThunk(
  "deleteSubCatergoryMapping",
  async (payload) => {
    try {
      const response =
        await allAPI.subCategories.deleteSubCatergoryMapping(payload);

      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);

const categoriesSlice = createSlice({
  name: "subCategoriesData",
  initialState,
  reducers: {
    set: (state, action) => {
      console.log(action, "action");
    },
  },
  extraReducers: (builder) => {},
});

export const {} = categoriesSlice.actions;

export default categoriesSlice.reducer;
